// Vite environment variable loader.
// All client-exposed env vars must be prefixed with VITE_ per Vite default.
// API_BASE_URL defaults to the live production API for local dev convenience;
// override via .env.local for staging.

interface PublicEnv {
  apiBaseUrl: string;
  shopifyApiKey: string;
  appEnv: 'development' | 'staging' | 'production';
  sentryDsn: string;
  /**
   * Amazon Associates affiliate tag. When set, OTC + supplement
   * medications surface a small "Reorder on Amazon" link with this
   * tag appended. Empty string disables the feature entirely.
   * Public by design (the tag appears in the URL anyway).
   */
  amazonAffiliateTag: string;
}

export const env: PublicEnv = {
  apiBaseUrl:
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
    'https://api.medreview.otchealth.app',
  shopifyApiKey: (import.meta.env.VITE_SHOPIFY_API_KEY as string | undefined) ?? '',
  appEnv:
    (import.meta.env.VITE_APP_ENV as 'development' | 'staging' | 'production' | undefined) ??
    'development',
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN_WEB as string | undefined) ?? '',
  amazonAffiliateTag: (import.meta.env.VITE_AMAZON_AFFILIATE_TAG as string | undefined) ?? '',
};
